/* Model */
class LocalzIntegrationLogModel extends App.Models.BaseModel {
  modelUrl = 'LocalzIntegrationLog';
}

App.Models.LocalzIntegrationLog = LocalzIntegrationLogModel;

/* Collection */
class LocalzIntegrationLogCollection extends App.Collections.BaseCollection {
  url = 'LocalzIntegrationLog';
  model = App.Models.LocalzIntegrationLog;
}

App.Collections.LocalzIntegrationLogs = LocalzIntegrationLogCollection;

/* Router */
class LocalzIntegrationLogRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'LocalzIntegrationLog';
    const model = App.Models.LocalzIntegrationLog;
    const collectionClass = App.Collections.LocalzIntegrationLogs;

    super(entityName, model, collectionClass);
  }

  removeSaveGridLayoutButton = function () {
    const tabId = this.getTabIdSelector();
    const saveGridButton = document.querySelector(`#${tabId} .saveLayout.gridActionDiv`);

    saveGridButton && saveGridButton.remove();
  };


  makeListScreen = (layout) => {
    this.collectionFilter = Monet.Grid.Utils.getFilterToSearch(this.entityName);
    this.collectionCriteria = null;

    if (layout) {
      const tabIdSelector = this.getTabIdSelector();

      if (!this.permissionDenied) {
        Monet.Form.checkFormTemplate(tabIdSelector);
        this.generateDatamapper(this.entityName, layout);

        const form = this.renderMonetForm(this.entityName, layout, tabIdSelector);

        form.initializeGrid(this.customGridActions);

        this.removeSaveGridLayoutButton();

        this.local_collection = this.collection;
        this.collectionCriteria = this.getProjectionBasedOnIndex();

        this?.beforeList();

        this.executeCustomFilter(this.entityName);
      }
    } else {
        //Sem informação de layout, verifique se o servidor está funcionando corretamente
        new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
            .show();
    }

    return this;
  };
}

App.Routers.LocalzIntegrationLog = LocalzIntegrationLogRouter;
